import '.c7{font-size:1.125rem;}.ssr-plugin'
import '.eb{line-height:1.75rem;}.ssr-plugin'
import '.e9{text-decoration:none;}.ssr-plugin'
import '.fm{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="c7 eb"
    >
      {translations.privacySubtitle}{' '}
      <a className="e9 fm"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="e9 fm"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
